import { Injectable } from '@angular/core';
import * as error from '../components/error-summary/error-handler.function';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

@Injectable()
export class HeadlessCmsService {

  constructor(private http: Http) { }

  getGenericContentByPath(path: string) {
    const url = `/umbraco/api/HeadlessCms/GetGenericContentByPath?path=${path}`;
    return this.http.get(url)
      .map((response: Response) => response.json())
      .catch(error.handleError);;
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/headless-cms.service.ts